import type { Form } from './types';
import { QUESTION_FORMAT } from './types';

import FreeText from './screens/FreeText';
import Select from './screens/Select';
import UploadPictures from './screens/UploadPictures';

export const JOB_REFINEMENT_API_ENABLED = false;

export const screens = {
  [QUESTION_FORMAT.SINGLE_SELECT]: Select,
  [QUESTION_FORMAT.MULTI_SELECT]: Select,
  [QUESTION_FORMAT.MULTI_SELECT_VISUAL]: Select,
  [QUESTION_FORMAT.SINGLE_SELECT_VISUAL]: Select,
  [QUESTION_FORMAT.JOB_PREFERRED_STARTS]: Select,
  [QUESTION_FORMAT.TEXT]: FreeText,
  [QUESTION_FORMAT.JOB_DESCRIPTION]: FreeText,
  [QUESTION_FORMAT.PHOTO_UPLOAD]: UploadPictures,
};

export const getDefaultForm = (categoryId: number | string): Form => {
  const parsedCategoryId =
    typeof categoryId === 'string' ? parseInt(categoryId) : categoryId;
  return {
    formId: 'form-default',
    categoryId: parsedCategoryId,
    questions: [
      {
        questionId: 'job-preferred-start-default',
        required: true,
        title: 'When would you ideally like the job to start?',
        description: 'Help tradespeople understand your timeline',
        type: 'string',
        format: 'JOB_PREFERRED_STARTS',
        options: [
          {
            value: '018f809e-31fe-7ccd-b906-b4876df0c556',
            label: "I'm flexible",
          },
          {
            value: '018f809e-5354-74c8-85e7-9aa6dead0de6',
            label: "It's urgent (within 48 hours)",
          },
          {
            value: '018f809e-721e-71fb-b52d-3312dffdc86f',
            label: 'Within 2 weeks',
          },
          {
            value: '018f809e-ad12-7811-ad8d-1d138f0e211d',
            label: 'Within 1 month',
          },
          {
            value: '018f809e-8be9-7d90-837e-3a16b6d017f2',
            label: "I'm budgeting / researching",
          },
        ],
        properties: {},
      },
      {
        questionId: 'job-description-default',
        required: true,
        title: 'Any other information to add?',
        description: 'Add any final details tradespeople should know',
        type: 'string',
        format: 'JOB_DESCRIPTION',
        options: [],
        properties: {
          minimum: 10,
          maximum: 500,
        },
      },
    ],
  };
};
